import WidgetBlogPost from './WidgetBlogPost'

export { WidgetBlogPost }
